import logo from './logo.svg';
// import './App.css';
import Main from './components/Main';
import 'moment/locale/fr';
import moment from 'moment';


moment.locale('fr')

function App() {
  return (
    <div className="App">
        <Main />
    </div>
  );
}

export default App;
